import React from 'react';
import { Link } from 'react-router-dom';
import { ArrowRight, CheckCircle, Zap, Award, Clock } from 'lucide-react';

const ServicesPage = () => {
  const services = [
   {
     title: "Express All-on-X Design",
      price: "$300", 
      period: "Same-day digital design for All-on-X cases",
      description: "Our Express All-on-X Design service delivers rapid, precise prosthetic designs using a fully digital workflow. Ideal for surgeons and labs needing same-day full-arch design support with accuracy and reliability.",
      features: [
        "Same-Day All-on-X Design",
        "Fast, precise digital workflow"
      ],
      icon: <Clock className="w-12 h-12 text-black" />,
      popular: false
    },
    {
       title: "Ace On-Site Tech - Photogrammetry",
      price: "$500 Starting ",
      // period: "for in-office print on day of surgery",
      description: "Our On-Site photogrammetry service ensures highly accurate implant capture for full-arch cases. Achieve precise, same-day results with faster turnaround and improved patient comfort.",
      features: [
        "On-Site chairside scanning ",
        "Advanced photogrammetry technology",
        "Ideal for full-arch implant cases",
        "Nationwide availability (location based pricing)"
      ],
      icon: <Award className="w-12 h-12 text-black" />,
      popular: true
    },



    {
      // title: "Full Arch Day of Surgery to Delivery",
      // price: "$00",
      // period: "Per Arch",
      // description: "Includes same-day temporary design, finished monolithic zirconia, and up to 3 design adjustments if needed.",
      // features: [
      //   "Same-day temporary design",
      //   "Finished monolithic zirconia",
      //   "Up to 3 design adjustments",
      //   "Complete upper or lower teeth",
      //   "Implant-supported solution"
      // ],
       title: "The Ace Package - Zirconia",
      price: "$1,550 Starting",
      period: "From day of surgery to final zirconia delivery",
      description: "The Ace Package – Zirconia provides a complete full-arch solution from start to finish. This package includes same-day provisional design, multiple adjustment options, and a premium final zirconia restoration built for long-term strength, function, and aesthetics.",
      features: [
        "Same-day temporary design",
        "Up to 3 design adjustments", 
        "Final Zirconia Restoration",
        "Premium, durable full-arch restorations"
      ],
      icon: <Zap className="w-12 h-12 text-black" />,
      popular: false
    },
      // title: "Final Zirconia Prosthesis with Substructure", 
      // price: "$00",
      // period: "Per Arch",
      // description: "Zirconia prosthesis with a zirconia or titanium bar substructure, cemented for long-term durability and support.",
      // features: [
      //   "Zirconia or titanium bar substructure",
      //   "Cemented for long-term durability",
      //   "Premium aesthetic appeal",
      //   "Superior strength and support",
      //   "High-quality zirconia material"
      // ],
    
    
      // title: "Same Day All-on-X Design Only",
      // price: "$00", 
      // period: "Per Arch",
      // description: "Immediate load design on the day of surgery, includes up to 2 designs.",
      // features: [
      //   "Immediate load design",
      //   "Day of surgery service",
      //   "Up to 2 designs included",
      //   "Fast and efficient process",
      //   "In-office printing available"
      // ],
    
    // {
    //   title: "Extra Design Adjustment",
    //   price: "$00",
    //   period: "Per Adjustment", 
    //   description: "Additional prototype try-in before final delivery to perfect fit and esthetics.",
    //   features: [
    //     "Additional prototype try-in",
    //     "Perfect fit optimization",
    //     "Enhanced aesthetics",
    //     "Quality assurance",
    //     "Patient satisfaction focus"
    //   ],
    //   icon: <CheckCircle className="w-12 h-12 text-blue-600" />,
    //   popular: false
    // }
  ];

  const processSteps = [
    {
      step: "01",
      title: "Consultation & Assessment",
      description: "Initial consultation to understand your specific needs and treatment requirements."
    },
    {
      step: "02", 
      title: "Digital Design",
      description: "Advanced digital scanning and design using cutting-edge CAD/CAM technology."
    },
    {
      step: "03",
      title: "Precision Manufacturing", 
      description: "Expert craftsmanship combined with state-of-the-art milling and 3D printing."
    },
    {
      step: "04",
      title: "Quality Delivery",
      description: "Final inspection, quality assurance, and timely delivery to your practice."
    }
  ];

  return (
    <div className="min-h-screen pt-16">
      {/* Hero Section */}
      {/* { <section className="bg-gradient-to-br from-slate-900 via-blue-900 to-slate-900 py-20">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 text-center">
          <h1 className="text-4xl sm:text-5xl font-bold text-white mb-6">
            <span className="text-gray-300">Durable. Esthetic.</span>{' '}
            <span className="bg-gradient-to-r from-blue-400 to-cyan-300 bg-clip-text text-transparent">
              Precise.
            </span>
          </h1>
          <h2 className="text-2xl sm:text-3xl font-semibold text-blue-400 mb-8">
            Premium Dental Restorations That Deliver Results
          </h2>
          <p className="text-lg text-gray-300 max-w-3xl mx-auto leading-relaxed mb-10">
            Crafted with precision and care, our dental products combine cutting-edge technology and aesthetic excellence giving patients the confidence to smile again.
          </p>
          <Link
            to="/contact"
            className="inline-flex items-center bg-gradient-to-r from-blue-600 to-cyan-500 text-white px-8 py-4 rounded-lg font-medium hover:from-blue-700 hover:to-cyan-600 transition-all duration-200 group"
          >
            Book Consultation
            <ArrowRight className="ml-2 w-5 h-5 group-hover:translate-x-1 transition-transform" />
          </Link>
        </div>
      </section> } */}


      <section
      // bg-gradient-to-br from-slate-900 via-blue-900 to-slate-900  bg-cover bg-centerss bg-black/50
      // bg-gradient-to-r  to-cyan-400 bg-clip-text text-transparent
  className="relative   py-20   bg-black  " 
 
>
  <div className="absolute inset-0 "></div> {/* dark overlay */}
  <div className="relative max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 text-center">
    <h1 className="text-4xl sm:text-5xl font-bold text-white mb-6">
      <span className="text-white">Durable. Aesthetic.</span>{' '}
      <span className=" from-black-400  text-white ">
        Precise.
      </span>
    </h1>
    <h2 className="text-2xl sm:text-3xl font-semibold text-white mb-8">
      Premium Dental Restorations That Deliver Results
    </h2>
    <p className="text-lg text-white max-w-3xl mx-auto leading-relaxed mb-10">
     Crafted with precision and care, our dental products combine cutting-edge technology and aesthetic excellence, giving patients the confidence to smile again.
    </p>
    <Link
      to="/contact"
      // bg-gradient-to-r
      className="inline-flex items-center bg-white   from-blue-600 to-cyan-500 text-black px-8 py-4 rounded-lg font-medium hover:from-blue-700 hover:to-cyan-600 transition-all duration-200 group"
    >
      Send Case 
      <ArrowRight className="ml-2 w-5 h-5 group-hover:translate-x-1 transition-transform" />
    </Link>
  </div>
</section>



      



      {/* Services Grid */}
      {/* <section className="py-20 bg-white">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="text-center mb-16">
            <h2 className="text-3xl sm:text-4xl font-bold text-gray-900 mb-6">
              Pricing Details
            </h2>
            <p className="text-lg text-gray-600 max-w-3xl mx-auto leading-relaxed">
              At Ace Dental Lab, we provide premium-quality restorations at competitive rates. Our pricing is designed to give you clarity, confidence, and options that suit your patient's needs.
            </p>
          </div>

          <div className="grid md:grid-cols-2 lg:grid-cols-2 gap-8">
            {services.map((service, index) => (
              <div key={index} className={`relative bg-white rounded-2xl border-2 p-8 hover:shadow-xl transition-all duration-200 ${service.popular ? 'border-black shadow-lg' : 'border-black-200'}`}>
                {service.popular && (
                  <div className="absolute -top-4 left-1/2 transform -translate-x-1/2">
                    <span className="bg-black text-white px-4 py-2 rounded-full text-sm font-medium">
                      Most Popular
                    </span>
                  </div>
                )}

                <div className="flex items-start justify-between mb-6">
                  <div className="flex-1">
                    <div className="mb-4">{service.icon}</div>
                    <h3 className="text-xl font-semibold text-black mb-2">{service.title}</h3>
                    <div className="mb-4">
                      <span className="text-3xl font-bold text-black-600">{service.price}</span>
                      <div className="text-sm text-gray-600 mt-1">{service.period}</div>
                    </div>
                  </div>
                </div>

                <p className="text-gray-600 mb-6 leading-relaxed">{service.description}</p>

                <ul className="space-y-3 mb-8">
                  {service.features.map((feature, featureIndex) => (
                    <li key={featureIndex} className="flex items-start space-x-3">
                      <CheckCircle className="w-5 h-5 text-green-500 flex-shrink-0 mt-0.5" />
                      <span className="text-gray-600 text-sm">{feature}</span>
                    </li>
                  ))}
                </ul>

                <Link
                  to="/contact"
                  className={`block w-full text-center py-3 px-6 rounded-lg font-medium transition-all duration-200 ${
                    service.popular
                    // bg-gradient-to-r hover:text-black hover:bg-black 
                      ? 'bg-black  from-blue-600 to-cyan-500 text-white hover:from-blue-700 hover:to-cyan-600'
                      : 'border-2 border-black text-black '
                  }`}
                >
                  Book Now
                </Link>
              </div>
            ))}
          </div>
        </div>
      </section> */}

      {/* Pricing / Services Grid */}
<section className="py-20 bg-black">
  <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
    <div className="text-center mb-16">
      <h2 className="text-3xl sm:text-4xl font-bold text-white mb-6">
        Pricing Details
      </h2>
      <p className="text-lg text-white max-w-3xl mx-auto leading-relaxed">
        At Ace Dental Lab, we provide premium-quality restorations at competitive rates, giving you clarity, confidence, and options that suit your patients’ needs.
      </p>
    </div>

    <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-8 items-stretch">
      {services.map((service, index) => (
        <div
          key={index}
          className={`relative bg-white rounded-2xl border-2 p-8 hover:shadow-xl transition-all duration-200 flex flex-col h-full ${
            service.popular ? 'border-black shadow-lg' : 'border-black-200'
          }`}
        >
          {service.popular && (
            <div className="absolute -top-4 left-1/2 -translate-x-1/2">
              <span className="bg-black text-white px-4 py-2 rounded-full text-sm font-medium">
                Most Popular
              </span>
            </div>
          )}

          <div className="flex-1">
            <div className="flex items-start justify-between mb-6">
              <div className="flex-1">
                <div className="mb-4">{service.icon}</div>
                <h3 className="text-xl font-semibold text-center  text-black mb-2">
                  {service.title}
                </h3>
                <div className="mb-4">
                  <span className="text-2xl font-semibold      text-black-600">
                    {service.price}
                  </span>
                  {service.period && (
                    <div className="text-sm text-gray-600 mt-1">
                      {service.period}
                    </div>
                  )}
                </div>
              </div>
            </div>

            <p className="text-gray-600 mb-6 leading-relaxed">
              {service.description}
            </p>

            <ul className="space-y-3 mb-6">
              {service.features.map((feature, featureIndex) => (
                <li
                  key={featureIndex}
                  className="flex items-start space-x-3"
                >
                  <CheckCircle className="w-5 h-5 text-green-500 flex-shrink-0 mt-0.5" />
                  <span className="text-gray-600 text-sm">
                    {feature}
                  </span>
                </li>
              ))}
            </ul>
          </div>

          {/* Button pinned to bottom */}
          <div className="mt-auto pt-4">
            {/* <Link
              to="/contact"
              className={`block w-full text-center py-3 px-6 rounded-lg font-medium transition-all duration-200 ${
                service.popular
                  ? 'bg-black text-white'
                  : 'border-2 border-black text-black'
              }`}
            >
              Book Now
            </Link> */}
             <Link
          to="/contact"
          className={`block w-full text-center py-3 px-6 rounded-lg font-medium transition-all duration-200 ${
            service.popular
              ? 'bg-black text-white'
              : 'border-2 border-black text-black'
    }`}
  >
    {service.title === "Ace On-Site Tech - Photogrammetry" ? "Book Now" : "Send Case"}
  </Link>
          </div>
        </div>
      ))}
    </div>
  </div>
</section>



      {/* Process Section  bg-gradient-to-r from-slate-50 to-blue-50  from-blue-600 to-cyan-500 */}
      {/* style={{ backgroundImage: "url('/Images/bg blackedit.jpg')" }} */}
      <section className="py-20 bg-black "    >
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="text-center mb-16">
            <h2 className="text-3xl sm:text-4xl font-bold text-white mb-6">
              Our Process
            </h2>
            <p className="text-lg text-white max-w-3xl mx-auto leading-relaxed">
              From initial consultation to final delivery, we ensure every step meets our high standards for quality and precision.
            </p>
          </div>

          <div className="grid md:grid-cols-2 lg:grid-cols-4 gap-8">
            {processSteps.map((process, index) => (
              <div key={index} className="text-center">
                {/* bg-gradient-to-br */}
                <div className=" bg-white    text-black w-16 h-16 rounded-full flex items-center justify-center text-xl font-bold mx-auto mb-6">
                  {process.step}
                </div>
                <h3 className="text-lg font-semibold text-white mb-3">{process.title}</h3>
                <p className="text-white text-sm leading-relaxed">{process.description}</p>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* CTA Section */}
      {/* bg-gradient-to-br  from-slate-900 via-blue-900 to-slate-900  */}
      <section className="py-20  bg-black  ">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 text-center">
          <h2 className="text-3xl sm:text-4xl font-bold text-white mb-6">
            Ready to Get Started?
          </h2>
          <p className="text-lg text-white mb-8 max-w-2xl mx-auto leading-relaxed">
            Connect with our expert team today to discuss your dental restoration needs and discover how we can help elevate your practice.
          </p>
          {/* <Link
            to="/contact"
            // bg-gradient-to-r
            className="inline-flex items-center bg-black   from-blue-600 to-cyan-500 text-white px-8 py-4 rounded-lg font-medium hover:from-blue-700 hover:to-cyan-600 transition-all duration-200 group text-lg"
          >
            Book Consultation
            <ArrowRight className="ml-2 w-5 h-5 group-hover:translate-x-1 transition-transform" />
          </Link> */}
        </div>
      </section>
    </div>
  );
};

export default ServicesPage;